import { render, staticRenderFns } from "./Successs.vue?vue&type=template&id=4aa91fea&scoped=true"
var script = {}
import style0 from "./Successs.vue?vue&type=style&index=0&id=4aa91fea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa91fea",
  null
  
)

export default component.exports